import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '../user/auth.service';
import { UserService } from '../user/user.service';
import { UIMesageService } from '../common/ui-message.service';
import { GoogleAnalyticsService } from '../common/google-analytics.service';
import { CreateRoomDialogComponent } from './create-room-dialog.component';
import { QrCodeDialogComponent } from '../qr-code/qr-code-dialog.component';

/**
 * Route component that triggers instant room creation.
 * Navigated to from the Astro website's "Create Room" button.
 *
 * - Logged-in user → create room immediately → navigate to room
 * - Not logged in → open name dialog → anonymous signup + room → navigate to room
 * - Dialog cancelled → redirect back to Astro homepage
 */
@Component({
    selector: 'create-room-route',
    template: '',
})
export class CreateRoomRouteComponent implements OnInit {

    private name: string;

    constructor(
        private router: Router,
        private dialog: MatDialog,
        private authService: AuthService,
        private userService: UserService,
        private uiMessage: UIMesageService,
        private googleAnalyticsService: GoogleAnalyticsService,
    ) {}

    async ngOnInit() {
        this.googleAnalyticsService.eventEmitter('createRoom', 'Home Page', 'createRoomAction');

        if (this.userService.isLoggedIn()) {
            await this.userService.createAndAssignUserRoom(this.authService.uid, this.authService.isAnonymous);
            this.navigateToRoomAndOpenQRCodeDialog();
        } else {
            this.openCreateRoomDialog();
        }
    }

    private openCreateRoomDialog(): void {
        const dialogRef = this.dialog.open(CreateRoomDialogComponent, {
            width: '450px',
            data: { name: this.name },
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.name = result;
                this.signup(result);
            } else {
                window.location.href = '/';
            }
        });
    }

    private async signup(name: string): Promise<void> {
        try {
            await this.authService.signUpAnonymous(name, true);
            this.navigateToRoomAndOpenQRCodeDialog();
        } catch (error) {
            this.uiMessage.error(error, 'Creating the room failed.');
        }
    }

    private navigateToRoomAndOpenQRCodeDialog(): void {
        this.router.navigate(['/room/' + this.userService.getRoomId() + '/scrum-poker']);
        this.dialog.open(QrCodeDialogComponent);
    }
}
